import { render, staticRenderFns } from "./MicrolearningViewEdit.vue?vue&type=template&id=b02e50dc&scoped=true"
import script from "./MicrolearningViewEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./MicrolearningViewEdit.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MicrolearningViewEdit.vue?vue&type=style&index=0&id=b02e50dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02e50dc",
  null
  
)

export default component.exports